import { Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export interface HideConfirmDialogData {
  contentType?: 'post' | 'comment';
}

@Component({
  selector: 'app-hide-confirm-dialog',
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './hide-confirm-dialog.html',
  styleUrl: './hide-confirm-dialog.css',
})
export class HideConfirmDialog {
  private dialogRef = inject(MatDialogRef<HideConfirmDialog>);
  private data: HideConfirmDialogData = inject(MAT_DIALOG_DATA, { optional: true }) || {};

  get contentLabel(): string {
    return this.data.contentType === 'comment' ? 'comment' : 'post';
  }

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
